import { DialogActions } from '@mui/material'
import ButtonUiKit from '../UI/button'
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined'
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined'
import { ISubmitDialogActionProps } from './IsubmitDialogActionProps'
import { FC } from 'react'

const SubmitDialogAction: FC<ISubmitDialogActionProps> = props => {
  return (
    <DialogActions sx={{ justifyContent: 'center' }} {...props}>
      <ButtonUiKit
        sx={{ width: '100px' }}
        onClick={props.onSubmit}
        type="submit"
        color="primary"
        variant="contained"
        startIcon={<CheckBoxOutlinedIcon />}
        loading={props.loading}
    
      >
        {props.submitlabel || 'ثبت'}
      </ButtonUiKit>
      {props.children}
      <ButtonUiKit
        sx={{ width: '100px' }}
        disabled={props.loading}
        onClick={props.onClose}
        color="error"
        variant="contained"
        startIcon={<DisabledByDefaultOutlinedIcon />}
      >
        {props.closeLabel || 'انصراف'}
      </ButtonUiKit>
    </DialogActions>
  )
}
export default SubmitDialogAction
